export default __webpack_public_path__ + "static/media/unit.6b2a6972.svg";